import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from 'src/app/app.routes.const';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent {
  constructor(private router: Router) {}

  navigateHome(): void {
    this.router.navigate([AppRoutes.Dashboard.fullPath()], {});
  }
}
